import { BaseEntityRes } from "./base";

export enum LOGIN_ID_TYPE {
  EMAIL = "email",
  PHONE = "phone",
}

export enum USER_TYPE {
  DL = "DIGITAL_LEGACY",
  SA = "SAMSUNG_ACCOUNT",
}

/**
 * User type codes with their corresponding number representations
 * @enum {string}
 */
export enum USER_TYPE_CODE {
  /** Individual user type (1) */
  INDIVIDUAL = "INDIVIDUAL",    
  /** Organization user type (2) */
  ORGANIZATION = "ORGANIZATION",
  /** Decedent user type (4) */
  DECEDENT = "DECEDENT",
  /** Developer user type (5) */
  DEVELOPER = "DEVELOPER",
  /** Verifier user type (6) */
  VERIFIER = "VERIFIER",
  /** Minor user type (7) */
  MINOR = "MINOR",
  /** Child user type (8) */
  CHILD = "CHILD",
  /** Legacy member user type (9) */
  LEGACY_MEMBER = "LEGACY_MEMBER",
}

export enum REQUEST_TYPE {
  DOWNLOAD = "A",
  DELETE = "E",
  UNSUBSCRIBE = "U",
}
export interface User {
  birthDate: string;
  countryCode: string;
  joinedDate?: string;
  loginId: string;
  loginIdType: string;
  mail: string;
  name: string;
  validatedEmail: string;
  userTypeCode: USER_TYPE_CODE;
  profileImageUrl?: string;
  userType?: USER_TYPE;
}

export interface UserRegion {
  isFromEurope?: boolean;
  isFromUS?: boolean;
  isRestricted?: boolean;
  isSAFromAmerica?: boolean;
  isSAFromUSA?: boolean;
  isSAFromEurope?: boolean;
  isSAFromMENA?: boolean;
}

export interface UserSurvey {
  isFetchingSurveyResponse: boolean;
  isSubmittingSurvey: boolean;
  hasAnsweredSurvey: boolean;
  hasErrors: boolean;
}

export interface Survey {
  survey_id?: number;
  answer_1: string;
  answer_2: string;
  answer_3: string;
  answer_4: string;
  comments?: string;
}

export interface UserEmailLoginInfo {
  fname: string;
  lname: string;
  email: string;
}

export interface SurveyEntityRes extends BaseEntityRes {}
